import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  Row,
  Table,
} from "reactstrap"
import { MdOutlineViewAgenda } from "react-icons/md"
import { useEffect, useRef, useState } from "react"
import { DataFilter, ItemsPerPage, SearchFilter } from "components/Common/filters"
import { useSelector, useDispatch } from "react-redux"
import PaginationComponent from "components/Common/pagination"
import Loader from "components/Common/loader"
import {
  allReturningStudents,
  ReturningStudentsFetch,
} from "redux/slice/returningStudentsSlice/returningStudentSlice"
import { DateFormater } from "utilities/dateformater"
import { convertCamelCaseToText } from "utilities/convertText"
import { Link, useNavigate } from "react-router-dom"
import { userData } from "redux/slice/user/userSlice"
import { SHUK_ROLE_VIWEWER } from "redux/enums"

export default function ReturningStudentsTable() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { userRole } = useSelector(userData) 
  const { returningStudentsData, loading, totalPages } = useSelector(
    allReturningStudents,
  )

  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState("")
  const [docUpload, setDocUpload] = useState("")

  const isViewer = userRole === SHUK_ROLE_VIWEWER
  

  const buildParams = (overrides = {}) => {
    const params = {
      Name: searchTerm,
      DocUpload: docUpload,
      pageNumber: currentPage,
      pageSize: itemsPerPage,
      ...overrides,
    }
    // Drop empty values so they are not sent as query params
    if (!params.Name) delete params.Name
    if (params.DocUpload === "" || params.DocUpload === undefined)
      delete params.DocUpload
    return params
  }

  const fetchReturningStudents = (overrides = {}) => {
    dispatch(ReturningStudentsFetch(buildParams(overrides)))
  }

  useEffect(() => {
    fetchReturningStudents()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsPerPage, currentPage, docUpload])

  const paginate = pageNumber => {
    setCurrentPage(pageNumber)
  }

  const handleItemsPerPage = perPage => {
    if (Number(perPage) !== itemsPerPage) {
      setCurrentPage(1)
    }
    setItemsPerPage(Number(perPage))
  }

  const debounceTimeout = useRef(null)
  const handleSearch = text => {
    setSearchTerm(text)
    setCurrentPage(1)
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current)
    }
    debounceTimeout.current = setTimeout(() => {
      fetchReturningStudents({ Name: text, pageNumber: 1 })
    }, 1200)
  }

  return (
    <div className="application-table-container">
      <Row>
        <Col lg={12}>
          <Card className="app-table-card">
            <CardTitle className="fs-2 ms-3 dot-after">
              Returning Students
            </CardTitle>
            <CardBody>
              <div className="row">
                <div className="col-sm-12 col-md-6 me-auto float-start d-flex flex-column flex-wrap mb-1" />
                <div className="float-end col-sm-12 col-md-6 d-flex justify-content-end flex-row align-items-center">
                  <div className="me-3">
                    <SearchFilter
                      value={searchTerm}
                      label="Search Returning Students"
                      onChange={e => {
                        handleSearch(e.target.value)
                      }}
                    />
                  </div>
                  <div className="me-3" style={{ maxWidth: "30%" }}>
                    <DataFilter
                      label="Doc Upload"
                      options={[
                        { id: "true", name: "Yes" },
                        { id: "false", name: "No" },
                      ]}
                      value={docUpload}
                      onChange={e => {
                        setCurrentPage(1)
                        setDocUpload(e.target.value)
                      }}
                    />
                  </div>
                  <div>
                    <ItemsPerPage
                      value={itemsPerPage}
                      handleItemsPerPage={handleItemsPerPage}
                    />
                  </div>
                </div>
              </div>

              <div className="app-table-body">
                {loading ? (
                  <Loader />
                ) : (
                  <Table className="table mb-0 table-bordered h-100">
                    <thead>
                      <tr>
                        <th className="text-nowrap">Application ID</th>
                        <th className="text-nowrap">Submit Date</th>
                        <th className="text-nowrap">Student Name</th>
                        <th style={{ width: "20%" }} className="text-nowrap">
                          College Name
                        </th>
                        <th className="text-nowrap">Status</th>
                        <th className="text-nowrap">Student Email</th>
                        <th className="text-nowrap">Student Contact</th>
                        <th className="text-nowrap">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {returningStudentsData &&
                      returningStudentsData.length > 0 ? (
                        returningStudentsData.map(app => (
                          <tr key={app?.id} style={{ cursor: "pointer" }} onClick={() => navigate(`/returningStudents/${app?.id}`)}>
                            <td className="text-nowrap">{app?.applicationId}</td>
                            <td
                              className="text-nowrap text-truncate"
                              style={{ maxWidth: "50px" }}
                            >
                              {app?.submittedDate
                                ? DateFormater(app?.submittedDate)
                                : ""}
                            </td>
                            <td
                              className="text-nowrap text-truncate"
                              style={{ maxWidth: "200px" }}
                            >
                              {app?.firstName + " "}
                              {app?.middleName ? app?.middleName + " " : ""}
                              {app?.lastName ? app?.lastName : ""}
                            </td>
                            <td
                              style={{ maxWidth: "80px" }}
                              className="text-nowrap text-truncate"
                            >
                              {app?.instituteName}
                            </td>
                            <td className="text-nowrap">
                              {convertCamelCaseToText(app?.applicationStatus)}
                            </td>
                            <td
                              style={{ maxWidth: "100px" }}
                              className="text-nowrap text-truncate"
                            >
                              {app?.email}
                            </td>
                            <td
                              style={{ maxWidth: "80px" }}
                              className="text-nowrap text-truncate"
                            >
                              {app?.phoneNumber}
                            </td>
                            <td>
                              <div className="hover-text">
                                <Link to={`/returningStudents/${app?.id}`}>
                                  <MdOutlineViewAgenda
                                    style={{ cursor: "pointer" }}
                                    className="me-2 text-success"
                                    size={20}
                                  />
                                </Link>
                                <span className="tooltip-text">View</span>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} className="text-center py-4">
                            No returning students found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
            <CardFooter>
              <div className="d-flex justify-content-center justify-content-md-end justify-content-lg-end align-items-center flex-wrap">
                <div style={{ marginLeft: "4px" }}>
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    paginate={paginate}
                  />
                </div>
              </div>
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
